import * as React from "react";
import { Loader } from "lucide-react";
import { cn } from "../../../lib/utils";

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Size variant for the spinner */
  size?: "sm" | "md" | "lg" | "xl";
}

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-10 w-10",
} as const;

/**
 * Spinner - A loading indicator component using the Loader2 icon from lucide-react.
 *
 * @example
 * ```tsx
 * <Spinner size="md" />
 * <Spinner size="lg" className="text-primary" />
 * ```
 */
function Spinner({
  className,
  size = "md",
  ref,
  ...props
}: SpinnerProps & { ref?: React.Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      className={cn("flex items-center justify-center", className)}
      {...props}
    >
      <Loader
        className={cn("animate-spin text-icon-blue", sizeClasses[size])}
      />
    </div>
  );
}
Spinner.displayName = "Spinner";

export { Spinner };
